export default __webpack_public_path__ + "static/media/skp.afdad370.svg";